import Utf8 from 'crypto-js/enc-utf8'
import Base64 from 'crypto-js/enc-base64'

export const encode = (input) => Base64.stringify(Utf8.parse(input))

export const decode = (input) => Utf8.stringify(Base64.parse(input))
